import * as Sentry from '@sentry/browser';

import * as constants from '@/constants';
import i18n from '@/settings/i18n';
import { FlashMessage } from '@/types/flashMessage';

export const handleError = (
  setFlashMessage: (message: FlashMessage) => void,
  err: any,
) => {
  if (
    err.response &&
    err.response.status === 401 &&
    err.response.data &&
    err.response.data.error === constants.INVALID_ACCESS_TOKEN_ERROR
  ) {
    setFlashMessage({
      body: i18n.t('ui.error.unexpected_and_login'),
      isWarning: true,
    });
  } else {
    Sentry.captureException(err);

    setFlashMessage({
      body: i18n.t('ui.error.unexpected'),
      isWarning: true,
    });
  }
};
